import React from 'react'

function Footer() {
  return (
    <div className='footer'>
        <div className='footer-menu'>
            <li><a href="#">About</a></li>
            <li><a href="#experience">Skills</a></li>
            <li><a href="#projects">Projects</a></li>
            <li><a href="#contacts">Contact</a></li>
        </div>
        <p>Copyright&copy; 2024 Mihnea Nistor. All Rights Reserved</p>
    </div>
  )
}

export default Footer